import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { SquaresFour, Storefront, Users, Receipt, Warning, SignOut, CreditCard, UsersThree, Gear, ShieldCheck } from "@phosphor-icons/react";
import Logo from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";

const nav = [
  { to: "/admin", icon: SquaresFour, label: "Dashboard", end: true },
  { to: "/admin/businesses", icon: Storefront, label: "Businesses" },
  { to: "/admin/customers", icon: Users, label: "Customers" },
  { to: "/admin/cards", icon: CreditCard, label: "Kite Cards" },
  { to: "/admin/transactions", icon: Receipt, label: "Transactions" },
  { to: "/admin/fraud", icon: Warning, label: "Fraud" },
  { to: "/admin/users", icon: UsersThree, label: "Users" },
  { to: "/admin/config", icon: Gear, label: "Configurations" },
  { to: "/admin/security", icon: ShieldCheck, label: "Security" },
];

export default function AdminLayout() {
  const { logout, user } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen ok-bg grain relative flex">
      <aside className="hidden md:flex w-64 shrink-0 flex-col border-r border-black/8 p-5 sticky top-0 h-screen">
        <div className="flex items-center gap-2 mb-1">
          <Logo className="h-7" />
        </div>
        <p className="text-[10px] text-primary uppercase tracking-[0.2em] font-mono mb-7 ml-8">Platform admin</p>
        <nav className="flex-1 space-y-1">
          {nav.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={`admin-nav-${n.label.toLowerCase()}`}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm transition-colors ${isActive ? "bg-primary/15 text-primary font-semibold" : "text-muted-foreground hover:bg-black/5"}`}>
              <n.icon size={20} weight="duotone" /> {n.label}
            </NavLink>
          ))}
        </nav>
        <button data-testid="admin-logout" onClick={() => { logout(); navigate("/login"); }} className="flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm text-muted-foreground hover:bg-black/5">
          <SignOut size={20} /> Sign out
        </button>
      </aside>

      <div className="flex-1 min-w-0 flex flex-col">
        <header className="glass sticky top-0 z-10 flex items-center justify-between px-4 sm:px-6 py-3 sm:py-4">
          <span className="font-display font-semibold text-sm sm:text-base truncate">OneKite Administration</span>
          <span className="text-xs text-muted-foreground shrink-0 ml-2">{user?.name}</span>
        </header>
        <main className="flex-1 p-4 sm:p-6 max-w-6xl w-full pb-24 md:pb-6"><Outlet /></main>
        <nav className="md:hidden glass fixed bottom-0 inset-x-0 flex overflow-x-auto no-scrollbar px-2 py-2">
          {nav.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={`admin-mnav-${n.label.toLowerCase()}`} className={({ isActive }) => `flex flex-col items-center gap-0.5 px-3 py-1 rounded-lg text-[10px] shrink-0 ${isActive ? "text-primary" : "text-muted-foreground"}`}>
              <n.icon size={18} /> {n.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </div>
  );
}
